import { DeleteOutlineOutlined, Edit, Save } from '@mui/icons-material';
import {
  AlertColor,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import strings from 'common/Translation/Translate';
import Notification from 'components/Notification';
import { useEffect, useState } from 'react';

const RoomRateMappingRow = ({
  roomTypes,
  pageResponse,
  roomTypeVsCorporateRate,
  setRoomTypeVsCorporateRate,
  isAdd,
  setOpenForm,
  idx = '',
}: any) => {
  const [roomTypeId, setRoomTypeId] = useState<any>('');
  const [corporateRate, setCorporateRate] = useState<any>([]);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const [roomTypeError, setRoomTypeError] = useState<boolean>(false);
  const [corporateRateReqError, setCorporateRateReqError] = useState<boolean>(false);
  const [corporateRateLessThanZeroError, setCorporateRateLessThanZeroError] = useState<boolean>(false);

  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: string;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  const [isEnabled, setIsEnabled] = useState<boolean>(false);

  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };

  useEffect(() => {
    setRoomTypeId(pageResponse.roomTypeId || '');
    setCorporateRate(pageResponse.rate || '');
  }, [pageResponse]);

  useEffect(() => {
    setIsEnabled(isAdd || isEditMode);
  }, [isAdd, isEditMode]);

  const handleSave = () => {
    if (roomTypeId === '') setRoomTypeError(true);
    else if (corporateRate === '') setCorporateRateReqError(true);
    else if (corporateRate < 0) setCorporateRateLessThanZeroError(true);
    else if (
      roomTypeVsCorporateRate.findIndex((r: any, i: number) => r.roomTypeId === roomTypeId && i !== idx) !== -1
    ) {
      setMessage({
        display: true,
        severity: 'error',
        message: strings.duplicateCorporateRate,
      });
    } else {
      if (!isEditMode) {
        setOpenForm(false);
        setRoomTypeVsCorporateRate((prev: any) => {
          prev.unshift({
            roomTypeId: roomTypeId,
            rate: corporateRate,
          });
          return prev;
        });
      } else {
        setRoomTypeVsCorporateRate((prev: any) => {
          prev.splice(idx, 1, {
            roomTypeId: roomTypeId,
            rate: corporateRate,
          });
          return [...prev];
        });
      }
    }
  };

  const handleDelete = () => {
    setRoomTypeVsCorporateRate((prev: any) => {
      prev.splice(idx, 1);
      return [...prev];
    });
  };

  return (
    <>
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <Grid container spacing={3}>
        <Grid item sx={{ width: '45%' }}>
          <FormControl size="small" sx={{ width: '-webkit-fill-available' }}>
            <InputLabel id="demo-simple-select-label">{strings.bookingDetailsRoomType}</InputLabel>
            <Select
              label={strings.bookingDetailsRoomType}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              data-testid="select"
              disabled={!isEnabled}
              value={roomTypeId}
              onChange={(event: any) => {
                const v = event.target.value;
                setRoomTypeId(v);
                setRoomTypeError(v === '');
                setCorporateRate('');
                setCorporateRateReqError(false);
                setCorporateRateLessThanZeroError(false);
              }}
              error={roomTypeError}>
              {roomTypes.map((item: any) => (
                <MenuItem key={item.id} role="item" value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography
            sx={{ fontSize: '10px', color: 'red', pt: 0.2, visibility: roomTypeError ? 'visible' : 'hidden' }}>
            {strings.requiredText}
          </Typography>
        </Grid>
        <Grid item sx={{ width: '45%' }}>
          <TextField
            sx={{ width: '-webkit-fill-available' }}
            label={strings.corporateRate}
            size="small"
            required
            data-testid="text"
            id="outlined-required"
            value={corporateRate}
            type="text"
            disabled={!isEnabled}
            onChange={e => {
              const v = e.target.value;
              if (!Number.isNaN(Number(v))) {
                setCorporateRate(v);
                setCorporateRateLessThanZeroError(parseInt(v) < 0);
              }
              setCorporateRateReqError(v === '');
            }}
            error={corporateRateReqError || corporateRateLessThanZeroError}
          />
          <Typography
            sx={{
              fontSize: '10px',
              color: 'red',
              pt: 0.2,
              visibility: corporateRateReqError || corporateRateLessThanZeroError ? 'visible' : 'hidden',
            }}>
            {corporateRateReqError ? strings.requiredText : strings.lessThaZeroError}
          </Typography>
        </Grid>
        <Grid item sx={{ width: '5%' }}>
          <IconButton
            data-testid="add_btn"
            onClick={() => {
              if (isEditMode || isAdd) {
                handleSave();
              } else {
                setIsEditMode(true);
              }
              isEditMode && setIsEditMode((prev: any) => !prev);
            }}>
            {isEditMode || isAdd ? <Save color="primary" /> : <Edit color="primary" />}
          </IconButton>
        </Grid>
        <Grid item sx={{ width: '5%' }}>
          {/* {!isAdd && ( */}
          <IconButton data-testid="delete_btn" onClick={handleDelete}>
            <DeleteOutlineOutlined color="primary" />
          </IconButton>
          {/* )} */}
        </Grid>
      </Grid>
    </>
  );
};
export default RoomRateMappingRow;
